import { UserType } from 'types';
import { EventStatus } from 'store/api/event';

const baseTitles = [
  'Name',
  'Between dates',
  'State',
  'City',
  'Attendance',
  'Rating',
];

export const titlesByUserType: Record<UserType, string[]> = {
  client: [...baseTitles, 'Status', 'Last edited', 'Last edited by', ''],
  ops: [...baseTitles, 'Client', 'Status', 'Last edited', 'Last edited by'],
};

// Desktop columns (owner 18 Oct sweep): at 1440 the old equal-fr template
// left the event name 73px and cut the date range ("08/25/2026 - 08/29/20…").
// Name gets the room; the date range, attendance and the 5-star rating get
// fixed widths that fit their content; columns sit 16px apart on desktop.
export const EVENT_LIST_DESKTOP_GAP = 16;

export const getTemplateByUserType = (
  userType: UserType,
  customActionWidth?: number
): string => {
  const baseTemplate =
    userType === 'ops'
      ? 'minmax(0, 2.5fr) 160px repeat(2, minmax(0, 1fr)) 88px 128px repeat(3, minmax(0, 1fr)) 120px'
      : 'minmax(0, 2.5fr) 160px repeat(2, minmax(0, 1fr)) 88px 128px minmax(0, 1.4fr) repeat(2, minmax(0, 1fr)) 120px';

  if (customActionWidth) {
    return `${baseTemplate} ${customActionWidth}px`;
  }

  return baseTemplate;
};

export const eventStatusText: Record<EventStatus, string> = {
  new: 'New',
  offered: 'Offered',
  accepted: 'Accepted',
};

// Phone: the date range gets its own full row (in half a card,
// "08/25/2026 - 08/29/20…" was cut at 390px).
export const cellsMobile = [
  { row: '1/2', col: '1/3' },
  { row: '2/3', col: '1/3' },
  { row: '3/4', col: '1/2' },
  { row: '3/4', col: '2/3' },
  { row: '4/5', col: '1/2' },
];
